import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { QueryOpts } from "./useTrackingEvents";

export interface FunnelStep {
	index: number;
	step: string;
	users_reached: number;
	conversion_from_prior: number;
	conversion_from_start: number;
}

export interface FunnelResponse {
	from: string;
	to: string;
	within_seconds: number;
	cohort: number;
	steps: FunnelStep[];
}

export interface FunnelArgs {
	steps: string[];
	from: Date;
	to: Date;
	withinSeconds?: number;
}

const fetchFunnel = async (args: FunnelArgs): Promise<FunnelResponse> => {
	const { data } = await cmsClient.get<FunnelResponse>("/tracking/funnels/", {
		params: {
			steps: args.steps.join(","),
			from: args.from.toISOString(),
			to: args.to.toISOString(),
			within: args.withinSeconds ?? 0
		}
	});
	return data;
};

const useTrackingFunnel = (args: FunnelArgs, options?: QueryOpts) =>
	useQuery(
		[
			"tracking",
			"funnel",
			args.steps.join(","),
			args.from.toISOString(),
			args.to.toISOString(),
			String(args.withinSeconds ?? 0)
		],
		() => fetchFunnel(args),
		{
			enabled: args.steps.length >= 2 && (options?.enabled ?? true)
		}
	);

export default useTrackingFunnel;
